<template>
  <StudioSelect
    id="fontDropdown"
    label="Font Type"
    :options="options"
    :value="selectedFontOption"
    size="small"
    orientation="horizontal"
    @change="e => onSelectFontOption(e.target.value)"
  />
</template>

<script>
import { themeHelper } from '@goldcast/uicomponents-branding';
import { mapGetters, mapMutations } from 'vuex';

import { StudioSelect } from '@/studioComponents';

export default {
  name: 'FontDropdown',
  components: { StudioSelect },
  props: {
    selectedFontOption: {
      type: String,
      required: true
    },
    moduleId: {
      type: String,
      required: true
    },
    hideFontDropdown: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      closeOnContentClick: true,
      options: [
        { value: 'Inter', label: 'Inter (Default)' },
        { value: 'Default-GT-America', label: 'GT America' },
        { value: 'Times New Roman', label: 'Times New Roman' },
        { value: 'Arial', label: 'Arial' },
        { value: 'Verdana', label: 'Verdana' },
        { value: 'Tahoma', label: 'Tahoma' },
        { value: 'Trebuchet', label: 'Trebuchet' },
        { value: 'Georgia', label: 'Georgia' },
        { value: 'Garamond', label: 'Garamond' },
        { value: 'Courier New', label: 'Courier New' },
        { value: 'Brush Script MT', label: 'Brush Script MT' },
        { value: 'Web Font', label: 'Web Font' },
        { value: 'Custom', label: 'Custom' }
      ]
    };
  },
  computed: {
    ...mapGetters('branding', ['theme_obj'])
  },
  watch: {
    theme_obj(value) {
      if (value.font_type !== 'Custom' || (value.font_type === 'Custom' && value.theme_font_src)) {
        themeHelper.loadFont(value.font_type, value.theme_font_src, value.theme_font_link);
      }

      if (
        value.splash_font_type !== 'Custom Splash' ||
        (value.splash_font_type === 'Custom Splash' && value.splash_theme_font_src)
      ) {
        themeHelper.loadFont(value.splash_font_type, value.splash_theme_font_src, value.splash_theme_font_link);
      }
    }
  },
  methods: {
    ...mapMutations('branding', {
      setChangesMadeInThemeObj: 'setChangesMadeInThemeObj'
    }),
    onSelectFontOption(selectedFontOption) {
      if (selectedFontOption === 'Inter') {
        this.handleFontSelect({ font_type: 'Inter', theme_font_name: 'Inter' });
      } else if (selectedFontOption === 'Default-GT-America') {
        this.handleFontSelect({ font_type: 'Default', theme_font_name: 'Default-GT-America' });
      } else if (selectedFontOption === 'Custom') {
        this.handleCustomFontSelect();
      } else if (selectedFontOption === 'Web Font') {
        this.handleWebFontSelect();
      } else {
        this.handleLibraryFontSelect(selectedFontOption);
      }
    },
    handleFontSelect({ font_type, theme_font_name }) {
      this.closeOnContentClick = true;
      this.$emit('setSelectedFontOption', font_type === 'Default' ? 'Default-GT-America' : font_type);

      if (this.moduleId === 'landingFont') {
        if (this.hideFontDropdown == true) {
          this.setChangesMadeInThemeObj({
            splash_font_type: font_type,
            splash_theme_font_name: theme_font_name,
            font_type: font_type,
            theme_font_name: theme_font_name
          });
        } else {
          this.setChangesMadeInThemeObj({
            splash_font_type: font_type,
            splash_theme_font_name: theme_font_name
          });
        }
      } else if (this.moduleId === 'heroBackgroundV2') {
        this.setChangesMadeInThemeObj({
          splash_font_type: font_type,
          splash_theme_font_name: theme_font_name
        });
      } else {
        this.setChangesMadeInThemeObj({
          font_type: font_type,
          theme_font_name: theme_font_name
        });
      }
    },
    handleCustomFontSelect() {
      this.$emit('setSelectedFontOption', 'Custom');
      if (this.moduleId === 'landingFont') {
        if (this.hideFontDropdown == true) {
          this.setChangesMadeInThemeObj({
            splash_font_type: 'Custom Splash',
            font_type: 'Custom'
          });
        } else {
          this.setChangesMadeInThemeObj({
            splash_font_type: 'Custom Splash'
          });
        }
      } else if (this.moduleId === 'heroBackgroundV2') {
        this.setChangesMadeInThemeObj({
          splash_font_type: 'Custom Splash'
        });
      } else {
        this.setChangesMadeInThemeObj({
          font_type: 'Custom'
        });
      }
    },
    handleLibraryFontSelect(font) {
      this.$emit('setSelectedFontOption', font);
      if (this.moduleId === 'landingFont') {
        if (this.hideFontDropdown == true) {
          this.setChangesMadeInThemeObj({
            splash_font_type: 'Web Safe Font',
            splash_theme_font_name: font,
            font_type: 'Web Safe Font',
            theme_font_name: font
          });
        } else {
          this.setChangesMadeInThemeObj({
            splash_font_type: 'Web Safe Font',
            splash_theme_font_name: font
          });
        }
      } else if (this.moduleId === 'heroBackgroundV2') {
        this.setChangesMadeInThemeObj({
          splash_font_type: 'Web Safe Font',
          splash_theme_font_name: font
        });
      } else {
        this.setChangesMadeInThemeObj({
          font_type: 'Web Safe Font',
          theme_font_name: font
        });
      }
    },
    handleWebFontSelect() {
      this.closeOnContentClick = true;
      this.$emit('setSelectedFontOption', 'Web Font');
      if (this.moduleId === 'landingFont') {
        if (this.hideFontDropdown == true) {
          this.setChangesMadeInThemeObj({
            splash_font_type: 'Web Font',
            font_type: 'Web Font'
          });
        } else {
          this.setChangesMadeInThemeObj({
            splash_font_type: 'Web Font'
          });
        }
      } else if (this.moduleId === 'heroBackgroundV2') {
        this.setChangesMadeInThemeObj({
          splash_font_type: 'Web Font'
        });
      } else {
        this.setChangesMadeInThemeObj({
          font_type: 'Web Font'
        });
      }
    }
  }
};
</script>
